import SingleProductComp from '../components/singleProductComp';

const SingleProduct = () => {
    return <SingleProductComp />;
};

export default SingleProduct;
